import React from "react";

import PropTypes from "prop-types";
import { useTranslation } from "react-i18next";

import { DEFAULT_CURRENCY } from "@shared/constants";

import { formatHoverText } from "@app/helpers/chart";

const CustomTooltip = props => {
  const {
    active = false,
    payload = [],
    dataType,
    translate,
    currency = DEFAULT_CURRENCY.code
  } = props;
  const { t } = useTranslation();
  if (!active || !payload?.length) {
    return null;
  }
  return (
    <div className="custom-tooltip">
      <p className="label label--xaxis">{payload[0].payload?.label}</p>
      {payload.map((p, i) => {
        const value = formatHoverText(p.value, dataType, undefined, currency);
        const label = translate ? t(p.name) : p.name;
        return (
          <p
            style={{ color: p.fill }}
            key={p.name + i}
            className="label"
          >{`${label} : ${value}`}</p>
        );
      })}
    </div>
  );
};

CustomTooltip.propTypes = {
  active: PropTypes.bool,
  payload: PropTypes.arrayOf(PropTypes.object),
  dataType: PropTypes.oneOf(["currency", "number", "percentage"]),
  translate: PropTypes.bool
};

export default CustomTooltip;
